{
  "titles": {
    "cashflow": "Cashflow"
  },
  "headings": {
    "iban": "IBAN",
    "period": "Periode",
    "balancePeriod": "Periode",
    "startBalance": "Startbalans",
    "endBalance": "Eindbalans",
    "balances": "Balans",
    "numberOfTransactions": "Aantal transacties",
    "mutation": "Mutatie",
    "percentageCategorized": "Percentage gecategoriseerd",
    "last30days": "Laatste 30 dagen",
    "30to60days": "30 tot 60 dagen geleden",
    "ytd": "Vanaf begin van het jaar",
    "last12Months": "Laatste 12 maanden"
  },
  "alerts": {
    "oldBankStatements": "De Bankafschriften zijn ouder dan 15 dagen. Vraag nieuwe afschriften aan voor account: {0}",
    "noMatchingEndBalance": "De betekende eindbalans komt niet overeen met de eindbalans van de MT940 bestanden voor account: {0}",
    "incorrectMutation": "De mutatie komt niet overeen met het verschil tussen de begin- en eindbalans voor account: {0}"
  },
  "total": "Totaal",
  "noAccountData": "Er zijn geen rekeninggegevens beschikbaar.",
  "unknownIban": "Onbekende IBAN"
}